import React from 'react';
import './style.scss';
import Dialog from '../../../components/general/dialog';
import Button from '../../../components/controls/button';
import Loader from '../../../components/general/loader';

interface Props {
  disconnected: boolean;
  connecting: boolean;
  error: boolean;
  unexpectedError: boolean;
  reconnect: () => void;
  exit: () => any;
}

const WSServiceDialog = ({
  disconnected,
  connecting,
  error,
  unexpectedError,
  reconnect,
  exit
}: Props) => (
  <Dialog
    opened={disconnected || connecting || error || unexpectedError}
    centered
    maxWidth='sm'
    fullWidth
    className='ws-service-dialog'
  >
    <DialogContent
      disconnected={disconnected}
      connecting={connecting}
      error={error}
      unexpectedError={unexpectedError}
      reconnect={reconnect}
      exit={exit}
    />
  </Dialog>
);

const DialogContent = ({
  disconnected,
  connecting,
  error,
  reconnect,
  unexpectedError,
  exit
}: Props) => {
  if (error || unexpectedError)
    return (
      <>
        <h2>{error ? 'Connection error!' : 'Unexpected server error'}</h2>
        <h4>Please refresh a page</h4>
        <Button onClick={() => window.location.reload()}>Refresh</Button>
      </>
    );

  if (connecting)
    return (
      <>
        <h2>Connecting to platform...</h2>
        <Loader size={80} />
        <Button
          variant='outlined'
          color='default'
          onClick={exit}
          className='min-width-200'
        >
          Cancel
        </Button>
      </>
    );

  if (disconnected)
    return (
      <>
        <h2>Connection lost!</h2>
        <Button onClick={reconnect} className='mb-10 min-width-200'>
          Reconnect
        </Button>
        <Button
          variant='outlined'
          color='default'
          onClick={exit}
          className='min-width-200'
        >
          Exit
        </Button>
      </>
    );

  return (
    <>
      <h2>&nbsp;</h2>
      <h4>&nbsp;</h4>
    </>
  );
};

export default WSServiceDialog;
